export default __webpack_public_path__ + "static/media/doggyRubb.ecf6fb09.gif";